import { pluralize, type PluralForms } from './pluralize';
import type { Language, TranslationsMap } from './types';

const DAY_FORMS: TranslationsMap<PluralForms> = {
  en: { one: 'day', few: 'days', many: 'days' },
  ru: { one: 'день', few: 'дня', many: 'дней' },
  uz: { one: 'kun', few: 'kun', many: 'kun' },
  fa: { one: 'روز', few: 'روز', many: 'روز' },
  pt: { one: 'dia', few: 'dias', many: 'dias' },
  tr: { one: 'gün', few: 'gün', many: 'gün' },
  uk: { one: 'день', few: 'дні', many: 'днів' },
  de: { one: 'Tag', few: 'Tage', many: 'Tage' },
  es: { one: 'día', few: 'días', many: 'días' },
  pl: { one: 'dzień', few: 'dni', many: 'dni' },
};

const pad = (n: number): string => String(n).padStart(2, '0');

export function formatCountdown(
  target: string | undefined,
  now: number,
  lang?: Language,
): string {
  if (!target) return '';

  const remaining = Math.max(0, new Date(target).getTime() - now);
  const totalHours = Math.floor(remaining / 3_600_000);
  const minutes = Math.floor((remaining / 60_000) % 60);
  const seconds = Math.floor((remaining / 1000) % 60);

  if (lang && totalHours >= 24) {
    const days = Math.floor(totalHours / 24);
    const word = pluralize(days, DAY_FORMS[lang], lang);
    return `${days} ${word} ${pad(totalHours % 24)}:${pad(minutes)}:${pad(seconds)}`;
  }

  return `${pad(totalHours)}:${pad(minutes)}:${pad(seconds)}`;
}
